import { useState } from "react";
import { toastError, toastSuccess } from "../../utils/toastUtils";
import MaterialIcon from "./MaterialIcon";

const CopyToClipboard = ({
  text,
  successMessage = "Copied!",
  errorMessage = "Copy failed!",
  copiedIcon = "check_circle",
  defaultIcon = "content_copy",
  resetDelay = 2000 // 2 seconds
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toastSuccess(successMessage);
        setCopied(true);
        setTimeout(() => setCopied(false), resetDelay);
      })
      .catch(() => toastError(errorMessage));
  };

  return (
    <MaterialIcon
      name={copied ? copiedIcon : defaultIcon}
      className={`cursor_pointer font_size_medium ${copied ? "text_success" : ""}`}
      onClick={handleCopy}
    />
  );
};

export default CopyToClipboard;
